import React, { FC } from 'react';
import styled from 'styled-components';

import { getCurrentAppLocaleObject } from '../../../lngProvider';

import { ReactComponent as SeedStarterSvg } from 'assets/images/investors/SeedStarter_coown.svg';
import { ReactComponent as SeedStarterSvgEn } from 'assets/images/investors/SeedStarter_coown_en.svg';

const SeedStarter: FC<{ className?: string }> = () => {
  const currentAppLocale = getCurrentAppLocaleObject();

  return <Image>{currentAppLocale.locale === 'cs-CZ' ? <SeedStarterSvg /> : <SeedStarterSvgEn />}</Image>;
};

const Image = styled.div`
  max-width: 250px;

  svg {
    width: 100%;
  }
`;

export default SeedStarter;
